import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
// 引入转换国际化
import  locale  from '../node_modules/element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';
// bus总线传值
Vue.prototype.bus = new Vue()
Vue.use(ElementUI, {locale} );

// html2canvas转换为图片
import html2canvas from 'html2canvas'
Vue.prototype.$html2canvas = html2canvas

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'PPfAuLG3w29Ye69ARD0dV2C93sGpEdhn'
})

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en',
  messages: {
    'en': require('@/assets/lang/en.js'),
    'zh': require('@/assets/lang/zh.js')
  }
});

Vue.filter("prefixed",(d)=>{
	const API_HOST = 'http://apt.highlander.com.cn:8889/storage/admin/';
	// const API_HOST = 'http://hlx.whwpy.com/storage/admin/';
	// const API_HOST = 'http://172.16.1.17/storage/admin/';
	if(!d || (typeof d !== 'string')) return ''
	return d.startsWith('http')?d:(API_HOST + d)
})


Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
